/* =============================================================================
 * Serializacao JSON compativel com o backend Prisma.
 *
 * O iPrisma sobrescreve Date.prototype.toJSON globalmente
 * (iPrisma\scripts\2DExtend.js:250-255) para emitir hora LOCAL com um sufixo
 * 'Z' FALSO. Todo o backend depende desse formato.
 *
 * Aqui NAO poluimos o prototipo global - isso quebraria qualquer biblioteca de
 * terceiros e todo JSON.stringify do app. Em vez disso usamos o truque do
 * replacer: ele recebe o valor JA' convertido por toJSON, mas o `this` e' o
 * objeto dono da propriedade, entao da' para alcancar a Date crua.
 * ========================================================================== */

function pad(n, tamanho = 2) {
    return String(n).padStart(tamanho, '0');
}

/** '2026-08-15T20:00:00.0Z' com os componentes LOCAIS (o 'Z' e' de fachada). */
export function dataParaTextoPrisma(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) + '.' + pad(d.getMilliseconds()) + 'Z';
}

/**
 * Use SEMPRE isto para montar o corpo de uma chamada a API - nunca
 * JSON.stringify direto, ou toda data enviada desloca pelo fuso horario.
 */
export function paraJsonPrisma(objeto) {
    return JSON.stringify(objeto, function (chave, valor) {
        const cru = this[chave]; // antes do toJSON nativo ter rodado
        if (cru instanceof Date) return dataParaTextoPrisma(cru);
        if (cru instanceof RegExp) return cru.toString();
        if (valor === undefined) return undefined;
        return valor;
    });
}
